var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_10689)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.718,
    cy: 270.418,
    r: 125.583,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.718,
    cy: 270.419,
    r: 83.2817,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 209.519,
    cy: 266.452,
    r: 29.0822,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.453 211.178C253.564 214.742 252.386 219.343 248.822 221.453L145.822 282.453L139 286.5C138.2 280.9 138.119 272.365 138.178 269.547L241.178 208.547C244.742 206.436 249.343 207.614 251.453 211.178Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.094 281.626C396.509 284.991 395.739 289.677 392.374 292.093L248.874 395.093C244.5 394.5 243.5 394.5 238.408 393.373C235.992 390.008 236.762 385.322 240.127 382.907L383.627 279.907C386.992 277.491 391.678 278.261 394.094 281.626Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.096 214.283C346.566 212.021 347.545 207.374 345.283 203.904C343.021 200.434 338.374 199.455 334.904 201.717L158.309 316.846L149 321.5C150.333 324.667 153.7 332.4 156.5 336L168 328.5L167.967 328.455L343.096 214.283ZM384.175 243.23C384.244 243.185 384.306 243.138 384.363 243.091L386 242C386 238.5 383.5 231 381.5 227L376.317 230.456C376.176 230.539 376.013 230.643 375.825 230.77L184.825 358.77C183.491 359.664 184.044 360.049 184.785 360.566C185.955 361.38 187.592 362.52 183 366.5C184.336 367.645 185.407 368.609 186.29 369.404L186.291 369.405L186.291 369.405C190.034 372.774 190.392 373.096 193.175 371.23L384.175 243.23Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.43 219.73C148.918 221.926 107.013 162.825 100 133H430.064C401.792 196.675 352.479 219.73 260.43 219.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 133C107.013 162.825 148.918 221.926 260.43 219.73C352.479 219.73 401.792 196.675 430.064 133",
    stroke: "#1C1B1F",
    strokeWidth: 20,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 364C179.5 362 184.5 359 187.5 357L189.5 372C187.1 370.8 183.166 367.167 180 364Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.784 474.682C-60.5339 363.822 -227.923 426.924 -293.101 474.594C-294.678 475.748 -294.681 478.01 -293.15 479.224C-235.44 524.959 -129.283 600.761 -88.4621 600.761C-37.3182 600.761 67.3376 521.507 116.213 479.444C117.73 478.139 117.478 475.747 115.784 474.682Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311 453.228L572.528 380",
    stroke: "#1C1B1F",
    strokeWidth: 23,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.59 511.703L575.938 553.524",
    stroke: "#1C1B1F",
    strokeWidth: 23,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_10689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/안과_백내장.02c8e72952958ee74731046ed46dfb81.svg";
export { ForwardRef as ReactComponent };